import { useMemo } from 'react'

import { CONTROL_CENTRE_API_DOMAIN } from '@/config/constants'
import useAuthenticatedQuery from '@/hooks/useAuthenticatedQuery'
import { QUERY_KEYS } from '../utils/queryKeys'
import type { AdminClientItem, PaginatedResponse } from '@/types/controlCenter'

const useAdminClients = () => {
  const { data, isLoading, error } = useAuthenticatedQuery<
    PaginatedResponse<AdminClientItem>
  >(
    QUERY_KEYS.clients,
    `${CONTROL_CENTRE_API_DOMAIN}/admin/clients?page=0&size=100`,
  )

  const clients = useMemo(() => data?.data ?? [], [data])

  const { clientMap, clientNameToId } = useMemo(
    () => ({
      clientMap: Object.fromEntries(
        clients.map((c) => [c.id, c.name]),
      ) as Record<number, string>,
      clientNameToId: Object.fromEntries(
        clients.map((c) => [c.name, c.id]),
      ) as Record<string, number>,
    }),
    [clients],
  )

  return { clients, clientMap, clientNameToId, isLoading, error }
}

export default useAdminClients
